import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Table, Button, Breadcrumb, Modal, Form } from '@themesberg/react-bootstrap';
import axiosInstance from "../../api/api";
import EditForm from "./DetailOption/EditFormPage";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHome, faInfoCircle, faEdit } from "@fortawesome/free-solid-svg-icons";
import CreateForm from "./DetailOption/CreateFormPage";
import ReactQuill from "react-quill";

const DetailOptionPage = () => {
    const { id } = useParams(); // Obtener el id de la URL
    const [showModal, setShowModal] = useState(false);
    const [selectedId, setSelectedId] = useState(null);
    const [optionId, setOptionId] = useState(null);

    // Estado para edición rápida de Tooltip y Modal
    const [showRTModal, setShowRTModal] = useState(false);
    const [rtField, setRtField] = useState(null);
    const [rtItem, setRtItem] = useState(null);
    const [rtValue, setRtValue] = useState("");

    // Datos de ejemplo filtrados por id
    const [data, setData] = useState([]);

    const handleRichTextEdit = (item, field) => {
        setRtItem(item);
        setRtField(field);
        setRtValue(item[field] || "");
        setShowRTModal(true);
    };

    const handleSaveRichText = async (e) => {
        e.preventDefault();
        const updatedItem = { ...rtItem, [rtField]: rtValue };
        try {
            await axiosInstance.post(`/detailoption/`, updatedItem);
            alert("Texto actualizado correctamente");
            setShowRTModal(false);
            fetchTableOption();
        } catch (error) {
            console.error("Error al guardar texto enriquecido:", error);
            alert("Error al guardar los datos.");
        }
    };

    const fetchTableOption = async () => {
        try {
            const response = await axiosInstance.get('/detailoption/option/' + id); // Endpoint del backend
            setData(response.data.data); // Guardar los datos del menú en el estado
            //setLoading(false); // Indicar que la carga ha terminado
        } catch (error) {
            console.log(error.message); // Guardar el mensaje de error
            //setLoading(false); // Indicar que la carga ha terminado
        }
    };

    const handleEdit = (id) => {
        setSelectedId(id);
        setOptionId(null);
        setShowModal(true);
    };

    const handleCreate = (optionId) => {
        setOptionId(optionId);
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setSelectedId(null);
    };

    const handleDelete = (id) => {
        const confirmDelete = window.confirm(`¿Estás seguro de eliminar el registro con ID: ${id}?`);
        if (confirmDelete) {
            alert(`Registro con ID: ${id} eliminado`);
        }
    };

    // Obtener el menú al cargar el componente
    useEffect(() => {
        fetchTableOption();
    }, []);

    const handleAdd = () => {
        fetchTableOption(); // Volver a obtener los datos actualizados del servidor
    };

    return (
        <div>
            <div className="d-xl-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
                <div className="d-block mb-4 mb-xl-0">
                    <Breadcrumb className="d-none d-md-inline-block"
                        listProps={{ className: "breadcrumb-dark breadcrumb-transparent" }}>
                        <Breadcrumb.Item><FontAwesomeIcon icon={faHome} /></Breadcrumb.Item>
                        <Breadcrumb.Item>Opciones</Breadcrumb.Item>
                    </Breadcrumb>
                    <h4>Listado de opciones :{id}</h4>
                    <p className="mb-0">
                        <CreateForm optionId={id} onAdd={handleAdd} />
                    </p>
                </div>
            </div>

            <Table striped bordered hover responsive>
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>Description</th>
                        <th>Value</th>
                        <th>Tooltip</th>
                        <th>Modal</th>
                        <th>Orden</th>
                        <th>Opciones</th>
                    </tr>
                </thead>
                <tbody>
                    {data.map(item => (
                        <tr key={item.id}>
                            <td>{item.id}</td>
                            <td>
                                <div className="d-flex align-items-center justify-content-between">
                                    <div dangerouslySetInnerHTML={{ __html: item.description }} />
                                    <Button variant="link" size="sm" className="p-0 text-info ms-2" onClick={() => handleRichTextEdit(item, 'description')} title="Editar Descripción">
                                        <FontAwesomeIcon icon={faEdit} size="lg" />
                                    </Button>
                                </div>
                            </td>
                            <td>{item.value}</td>
                            <td className="text-center align-middle">
                                <Button variant="link" size="sm" className="p-0 text-info" onClick={() => handleRichTextEdit(item, 'tooltip')} title="Editar Tooltip">
                                    <FontAwesomeIcon icon={faInfoCircle} size="lg" />
                                </Button>
                            </td>
                            <td className="text-center align-middle">
                                <Button variant="primary" size="sm" onClick={() => handleRichTextEdit(item, 'modal')} title="Editar Modal">
                                    Más información
                                </Button>
                            </td>
                            <td className="text-center align-middle">
                                {item.orden}
                            </td>
                            <td>
                                <Button variant="warning" size="sm" onClick={() => handleEdit(item.id)}>
                                    Editar
                                </Button>{' '}
                                <Button variant="danger" size="sm" onClick={() => handleDelete(item.id)}>
                                    Eliminar
                                </Button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>
            <EditForm id={selectedId} show={showModal} handleClose={handleCloseModal} onAdd={handleAdd} />

            {/* Modal para Edición Rápida de Texto Enriquecido */}
            <Modal show={showRTModal} onHide={() => setShowRTModal(false)} centered size="xl">
                <Modal.Header closeButton>
                    <Modal.Title>
                        Editar {rtField === 'tooltip' ? 'Tooltip' : rtField === 'modal' ? 'Modal' : 'Descripción'}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={handleSaveRichText}>
                        <Form.Group controlId="formRT" style={{ height: '300px' }}>
                            <Form.Label>Texto Enriquecido</Form.Label>
                            <ReactQuill
                                value={rtValue}
                                onChange={setRtValue}
                                style={{ height: '220px', marginBottom: '40px' }}
                                modules={{
                                    toolbar: [
                                        ['bold', 'italic', 'underline', 'strike'],
                                        ['list', 'bullet', 'indent', '-1', '+1'],
                                        ['link', 'image', 'video'],
                                    ],
                                }}
                            />
                        </Form.Group>
                        <Button variant="primary" type="submit" className="mt-5">
                            Guardar Cambios
                        </Button>
                    </Form>
                </Modal.Body>
            </Modal>
        </div>

    );
};

export default DetailOptionPage;